export const AboutUsPageTranslationsEn = {
  'About us': 'About Us',
};
